import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './types';
import { INursery } from 'v2/resources/types/nurseries';

const nurseriesSlice = createSlice({
  name: 'nurseries',
  initialState,
  reducers: {
    setNurseries: (state, action: PayloadAction<INursery[]>) => {
      return {
        ...state,
        nurseries: action.payload,
      };
    },
  },
});

export const { setNurseries } = nurseriesSlice.actions;

export default nurseriesSlice.reducer;
